import { useUnit } from 'effector-react'

import {
  $allPermissions,
  $inheritedRoles,
  $role,
  $rolePermissions,
  getRole,
  getRolePermissions,
} from './model'

export const useRoleDetails = () => {
  const role = useUnit($role)
  const inheritedRoles = useUnit($inheritedRoles)
  const rolePermissions = useUnit($rolePermissions)
  const allPermissions = useUnit($allPermissions)
  const loading = useUnit(getRole.pending)
  const permissionsLoading = useUnit(getRolePermissions.pending)

  return {
    role,
    inheritedRoles,
    rolePermissions,
    allPermissions,
    loading,
    permissionsLoading,
  }
}
